import { NominationRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryNominationRefs: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  accessToken?: string,
) => Promise<NominationRef[]> = (fetchContext, programId, countryId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nomination-refs`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<NominationRef[]>(fetchContext.errorStore, response, 'get country nomination refs'));
